import { render } from "./ControleRecursos.vue?vue&type=template&id=fb553812"
import script from "./ControleRecursos.vue?vue&type=script&lang=js"
export * from "./ControleRecursos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__